<aside class="ruts-menu h-full">
    <div class="menu_logo">
        <i class="ruts-icon icon-logo"></i>
    </div>

    <div class="menu-tochno">
        <p>
            <i class="pi pi-clock"></i>
            Сдача уточненок:
        </p>

        <div class="menu-tochno_date">
            <ng-container
                *ngIf="!(isLoading$ | async) && (user$ | async) as currentUser; else emptyTime">
                <span>{{ currentUser.tochnoTime | date: "dd.MM" }}</span>
                <span>{{ currentUser.tochnoTime | date: "HH:mm" }} (МСК)</span>
            </ng-container>

            <ng-template #emptyTime>
                <p-skeleton></p-skeleton>
            </ng-template>
        </div>
    </div>

    <button
        class="header_burger"
        icon="pi pi-times --icon-color-hover"
        iconPos="left"
        pButton
        type="button"
        *ngIf="!swdIsDesktop()"
        (click)="closeMenu()"></button>

    @if (user$ | async; as currentUser) {
        @if ((isLoading$ | async) === false) {
            <p-menu [model]="(menuItems$ | async) ?? []" />

            @if (currentUser.isBatrak && supportListIds.has(currentUser.userId)) {
                <a
                    pButton
                    href="https://t.me/supplaybe_bot"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="menu_contact-btn"
                    >Связаться с нами</a
                >
            }
        } @else {
            <div class="menu-skeleton">
                @for (item of (menuItems$ | async) ?? [] | slice: 0 : 7; track $index) {
                    <p-skeleton />
                }
            </div>
        }
    }
</aside>
